import * as angular from 'angular';
import security from '../../../service/security/security-services';
import datacatalog from '../../../integration/datacatalog/datacatalog-services';
import server from '../../../integration/server/server-services';
import nvdbapi from '../../../integration/nvdbapi/nvdbapi';
import {contractTypeMap} from '../../../model/enum-contractTypes';
import PermissionResolver from '../../../service/security/PermissionResolver';
import {AuthEvents} from '../../../service/security/security-module';
import {Contract} from '../../../integration/representation/contract';
import {ContractGroupWithData} from '../../../integration/representation/contract-group';

interface NewContractControllerState {
    counties: { [key: number]: string };
    roadCategories: { [key: string]: string };
    roadStatuses: { [key: string]: string };
    contractStatuses: { [key: string]: string };
    contractTypes:  { [key: string]: string };
    contractGroups: ContractGroupWithData[];
    hasGlobalCreatePermit: boolean;
    contract: Contract;
    sourceContract: DisplayContract;
    isSent: boolean;

    createContract: Function;
    formatDate: Function;
}

interface DisplayContract extends Omit<Contract, 'completionDate'> {
    completionDate: Date;
}

export default function NewContractController($rootScope: angular.IRootScopeService,
                                              $routeParams: angular.route.IRouteParamsService,
                                              $scope: any,
                                              $http: angular.IHttpService,
                                              $location: angular.ILocationService,
                                              $filter: angular.IFilterService,
                                              $q: angular.IQService,
                                              security: security,
                                              datacatalog: datacatalog,
                                              server: server,
                                              AUTH_EVENTS: AuthEvents,
                                              nvdbapi: nvdbapi) {
    const vm: NewContractControllerState = this;

    vm.counties = {};
    vm.roadCategories = {};
    vm.roadStatuses = {};
    vm.contractStatuses = {
        'PLANLAGT': 'Planlagt',
        'UTLYST': 'Utlyst',
        'IGANGSATT': 'Igangsatt',
        'FERDIG': 'Ferdig'
    };
    vm.contractTypes = contractTypeMap;
    vm.contractGroups = [];
    vm.hasGlobalCreatePermit = false;
    vm.contract = {} as Contract;
    vm.sourceContract = null;
    vm.isSent = false;

    vm.createContract = createContract;
    vm.formatDate = formatDate;

    function formatDate(date: Date) {
        if (!date.getDay) {
            return date;
        }

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const monthString = String((month >= 10) ? String(month) : '0' + String(month));
        const dayString = String((day >= 10) ? String(day) : '0' + String(day));
        return year + '-' + monthString + '-' + dayString;
    }

    function createContract() {
        if ($scope.contractForm.$invalid) {
            return;
        }

        vm.isSent = true;

        if (vm.sourceContract) {
            // copy contract
            server.createContract(vm.contract, false)
                .then(contract => {
                    const promises = [];
                    vm.sourceContract.contributors
                        .filter(contributer => contributer.username !== contract.assignee)
                        .forEach(contr => promises.push(server.addUserToContract(contract.id, contr.username)));
                    vm.sourceContract.milestones
                        .map(milestone => {
                            milestone.deadline = vm.formatDate(milestone.deadline);
                            return milestone;
                        })
                        .forEach(milestone => promises.push(server.createContractMilestone(contract.id, milestone)));

                    promises.push(server.saveObjectLists(contract.id, {
                        nvdb: vm.sourceContract.objectList,
                        fkb: vm.sourceContract.fkbObjectList
                    }));
                    $q.all(promises)
                        .then(() => {
                            security.readSession()
                                .then(() => {
                                    $location.url('/contract/' + contract.id + '/settings');
                                });
                        });
                });

        } else {
            // new contract
            server.createContract(vm.contract, true)
                .then(contract => {
                    security.readSession()
                        .then(() => {
                            $location.url('/contract/' + contract.id + '/settings');
                        });
                });
        }

    }

    function init() {

        // FIXME: This method is working entirely by accident and lucky timing

        security.ensureCurrentUser()
            .then(user => {
                const currentUser = user.username;
                const resolver = new PermissionResolver(user.permissions);
                vm.hasGlobalCreatePermit = resolver.hasPermission('CONTRACT:CREATE', PermissionResolver.GLOBAL_PERMISSION_SCOPE, PermissionResolver.GLOBAL_PERMISSION_SCOPE);

                nvdbapi.getCounties()
                    .then(response => {
                        response.data
                            .forEach(county => {
                                vm.counties[county.nummer] = county.navn;
                            });
                    }).catch(err => {
                    console.warn('Failed to load counties from API LES');
                });

                vm.roadCategories = datacatalog.getRoadCategories();
                vm.roadStatuses = datacatalog.getRoadStatuses();

                server.getContractGroupList().then(response => {
                    if (response.data) {
                        vm.contractGroups = response.data;
                    } else {
                        vm.contractGroups = [];
                    }
                    if (vm.contractGroups.length > 0 && !vm.hasGlobalCreatePermit) {
                        vm.contract.contractGroup = vm.contractGroups[0].id;
                    }
                });

                if ($routeParams.contractId) {
                    // copy contract
                    server.readContract($routeParams.contractId).then(sourceContract => {
                        vm.sourceContract = {...sourceContract, completionDate: new Date(sourceContract.completionDate)};
                        vm.contract = sourceContract;
                        vm.contract.assignee = currentUser;
                        vm.contract.name = 'Kopi av ' + vm.contract.name;
                        if (!vm.hasGlobalCreatePermit) {
                            server.getContractGroupForContract($routeParams.contractId).then(response => {
                                if (response.success) {
                                    vm.contract.contractGroup = response.data.groupid;
                                }
                            });
                        }
                    });
                } else {
                    vm.contract.assignee = currentUser;
                }
            });
    }

    function clear() {
        vm.createContract = undefined;
    }

    $scope.$on(AUTH_EVENTS.AUTH_LOGGED_IN, () => {
        init();
    });
    $scope.$on(AUTH_EVENTS.AUTH_LOGGED_OUT, () => {
        clear();
    });

    init();

}
NewContractController.$inject = ['$rootScope', '$routeParams', '$scope', '$http', '$location', '$filter', '$q', 'security', 'datacatalog', 'server', 'AUTH_EVENTS', 'nvdbapi'];
